import type {TMajorActionPassGoData} from '@kapitalist/contract/types'
import {skins} from '~/game/skins'
import {PassGoCard} from '~/models/game/Cards/ActionCard'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMajorActionUserFacingDescriptionData} from '~/models/game/MajorAction'
import MajorAction from '~/models/game/MajorAction'
import {mutateIf} from '~/utils/etc'
import {inTense, sentenceCase} from '~/utils/language'

export default class MajorActionPassGo extends MajorAction<TMajorActionPassGoData> {
  card: PassGoCard

  constructor(data: TMajorActionPassGoData) {
    super(data)
    this.card = new PassGoCard(data.card)
  }

  public userFacingDescription({
    tense,
    skin,
    gamePosition,
  }: TMajorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined
    const majorActor = gamePosition.majorActorPlayer
    const dropFirstNoun = tense === 'imperativePrompt'

    const actor = dropFirstNoun
      ? undefined
      : currentPlayer?.id === majorActor.id
        ? 'You'
        : majorActor.username

    return skins[skin].gameLogDescriptions.majorActions.passGo({
      tense,
      actor,
      playVerb: mutateIf(inTense(tense)('play'), dropFirstNoun, sentenceCase),
      cardName: this.card.displayName(skin),
    })
  }
}
